// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__DQmkM","checkmark":"Checkbox_checkmark__4g7VN"};